import { combineReducers } from 'redux';

import ruleset from './ruleset/rulesetReducer';

export default combineReducers({
	ruleset,
});
